export const womanData = [{
        "id": "1",
        "product": "Woman Wear",
        "image": "/assets/Woman/1.jpg",
        "type": "Dress",
        "brand": "Zara",
        "model": "Flowy Maxi",
        "price": "79.99",
        "category": "Clothing",
        "description": "A flowy maxi dress with floral patterns, perfect for summer occasions."
    },
    {
        "id": "2",
        "product": "Woman Wear",
        "image": "/assets/Woman/2.jpg",
        "type": "Blouse",
        "brand": "H&M",
        "model": "Classic Silk",
        "price": "49.90",
        "category": "Clothing",
        "description": "A classic silk blouse suitable for professional and casual settings."
    },
    {
        "id": "3",
        "product": "Woman Wear",
        "image": "/assets/Woman/3.jpg",
        "type": "Jeans",
        "brand": "Levi's",
        "model": "501 Skinny",
        "price": "89.50",
        "category": "Clothing",
        "description": "Skinny fit jeans with a classic 5-pocket design, perfect for everyday wear."
    },
    {
        "id": "4",
        "product": "Woman Wear",
        "image": "/assets/Woman/4.jpg",
        "type": "Jumpsuit",
        "brand": "Forever 21",
        "model": "Utility Jumpsuit",
        "price": "59.99",
        "category": "Clothing",
        "description": "A utility-style jumpsuit with a modern and versatile look."
    },
    {
        "id": "5",
        "product": "Woman Wear",
        "image": "/assets/Woman/5.jpg",
        "type": "Skirt",
        "brand": "Topshop",
        "model": "A-Line Mini",
        "price": "39.99",
        "category": "Clothing",
        "description": "A stylish A-line mini skirt with a retro touch, suitable for various occasions."
    },
    {
        "id": "6",
        "product": "Woman Wear",
        "image": "/assets/Woman/6.jpg",
        "type": "Sweater",
        "brand": "Gap",
        "model": "Cable Knit",
        "price": "49.95",
        "category": "Clothing",
        "description": "A cozy cable knit sweater with a timeless design, perfect for chilly days."
    },
    {
        "id": "7",
        "product": "Woman Wear",
        "image": "/assets/Woman/7.jpg",
        "type": "Blazer",
        "brand": "Mango",
        "model": "Tailored Blazer",
        "price": "79.99",
        "category": "Clothing",
        "description": "A tailored blazer with a chic silhouette, suitable for formal and casual looks."
    },
    {
        "id": "8",
        "product": "Woman Wear",
        "image": "/assets/Woman/8.jpg",
        "type": "Activewear",
        "brand": "Lululemon",
        "model": "Align Leggings",
        "price": "98.00",
        "category": "Clothing",
        "description": "High-quality leggings with a buttery soft feel, ideal for yoga and workouts."
    },
    {
        "id": "9",
        "product": "Woman Wear",
        "image": "/assets/Woman/8.jpg",
        "type": "Swimwear",
        "brand": "Secret",
        "model": "Bikini Set",
        "price": "59.50",
        "category": "Clothing",
        "description": "A stylish bikini set with vibrant patterns, perfect for beach days."
    },
    {
        "id": "10",
        "product": "Woman Wear",
        "image": "/assets/Woman/10.jpg",
        "type": "Pants",
        "brand": "Hollister",
        "model": "High-Rise Skinny",
        "price": "49.95",
        "category": "Clothing",
        "description": "High-rise skinny pants with a flattering fit, suitable for various occasions."
    },
    {
        "id": "11",
        "product": "Woman Wear",
        "image": "/assets/Woman/11.jpg",
        "type": "Coat",
        "brand": "Voltaire",
        "model": "Wool Blend Coat",
        "price": "299.00",
        "category": "Clothing",
        "description": "A stylish wool blend coat with a modern and elegant design, perfect for colder days."
    },
    {
        "id": "12",
        "product": "Woman Wear",
        "image": "/assets/Woman/12.jpg",
        "type": "T-Shirt",
        "brand": "Eagle",
        "model": "Graphic Tee",
        "price": "24.95",
        "category": "Clothing",
        "description": "A casual graphic tee with trendy prints, suitable for relaxed everyday outfits."
    }
]